import React from 'react';
import { css } from 'emotion';
import * as cs from './style';

export const AnimatedIcon = ({ type }) => {
  return (
    <div className={css`${cs.animatedIcon}`}>
      <div className="success-checkmark">
        <div className="check-icon">
          <span className="icon-line line-tip"></span>
          <span className="icon-line line-long"></span>
          <div className="icon-circle"></div>
          <div className="icon-fix"></div>
        </div>
      </div>
    </div>
    
  );
};

export default AnimatedIcon;